// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixData from 'wix-data'

function formatEventItem($item, itemData) {
	console.log("+++ Formatting item", itemData.nameShort, itemData)
    $item('#uxUpcomingName').text = itemData.nameShort || '-'
	$item('#uxUpcomingDescription').text = itemData.descriptionShort || '-'
	$item('#uxUpcomingDates').text = itemData.datesString
	$item('#uxTempEndDate').text = ''
}

$w.onReady(async function () {	
})


export async function dataEventRegistrations_ready() {
	// Filter data source
	// after the initial state is ready so it's safe to modify
	const now = new Date()
	let filter = wixData.filter()
		.eq('isPublished', true)
		.eq('isFeatured', true)
		// assumption: all events have start and end date, even if they are the same
		// don't show future events
		.ge('endDate', now)	

	
		console.log("Applying dynamic filter...")
		await $w('#dataEventRegistrations').setFilter(filter)
		console.log("Filter set.")
		$w('#uxUpcomingEventsRepeater').forEachItem(($item, itemData, index) => {
			formatEventItem($item, itemData)
	    })			
}

export function uxUpcomingEventsRepeater_itemReady($item, itemData, index) {
	// console.log("--- item ready", itemData.nameShort, itemData)
}